/* @flow */
const allGradesValue = 'All grades';

export default {
  allGradesValue,
};
